import React from "react";

import Heading from "./Heading";
import Data from "./Data";
import Input from "./Input";

class Column extends React.Component {
  render() {
    const { type, isEditing, isCreating, isCreateRow, column } = this.props;
    const noEdit = column.noEdit === true;
    const canAdd = column.canAdd === true;

    if (type === "header") {
      return <Heading {...this.props} />;
    }

    if ((isEditing && !noEdit) || (isCreating && canAdd)) {
      return <Input {...this.props} />;
    }

    if (isCreateRow) {
      return <Input {...this.props} />;
    }

    return <Data {...this.props} />;
  }
}

export default Column;
